import React, { Component } from 'react';
import { Input } from 'antd';
import { modes } from '@comall-backend-builder/types';

function pickGoodsNameLabel(source: any): string {
    if (!source) {
        return '';
    }
    const raw = source.goodsNameLabel != null ? source.goodsNameLabel : source.goods_name_label;
    if (raw == null) {
        return '';
    }
    return String(raw).trim();
}

function resolveGoodsNameLabel(info: any): string {
    if (!info) {
        return '';
    }
    const fromRow = pickGoodsNameLabel(info.row);
    if (fromRow) {
        return fromRow;
    }
    const entityFields = info.entity && info.entity.fields;
    return pickGoodsNameLabel(entityFields);
}

function formatShowNameDisplay(value: any, label: string): string {
    const name = value == null ? '' : String(value);
    if (!label) {
        return name;
    }
    return label + name;
}

/**
 * 展示名称：只读商品名称标签 + 可编辑展示名称底稿
 */
class ProductShowNameControl extends Component<any> {
    handleChange = (e: any) => {
        const { onChange, name } = this.props;
        if (onChange) {
            onChange(e.target.value, name);
        }
    };

    render() {
        const { value, label, disabled, placeholder, style } = this.props;
        return (
            <div className="product-show-name-control" style={style}>
                {label ? <span className="product-show-name-label">{label}</span> : null}
                <Input
                    className="product-show-name-input"
                    value={value}
                    onChange={this.handleChange}
                    disabled={disabled}
                    placeholder={placeholder}
                />
            </div>
        );
    }
}

export class StringShowNameMode extends modes.StringMode {
    getAvailableDisplayComponent(value: any, displayInfo: any) {
        const label = resolveGoodsNameLabel(displayInfo);
        const text = formatShowNameDisplay(value, label);
        const { className, style } = displayInfo || {};
        return (
            <span className={className} style={style}>
                {text}
            </span>
        );
    }

    getControlComponent(controlInfo: any) {
        const label = resolveGoodsNameLabel(controlInfo);
        return <ProductShowNameControl {...controlInfo} label={label} />;
    }
}
